import { useState, useEffect } from 'react';
import { Row, Col, Select, Form } from 'antd';
import UserConfig from "@/config/user";
import { getLangList } from '@/lib/i18n';
import { getOptionArray, selectFilterOption } from "@/lib/antdElementFunction";
import { TeacherType } from './types';
import TeacherSingle from './TeacherSingle';
import Teachers from './Teachers';

const { getAllTeacherAccount } = UserConfig;

function TeacherManagement() {
  const [teacherArray, setTeacherArray] = useState<TeacherType[]>([]);
  const [teacherInfo, setTeacherInfo] = useState({} as TeacherType);
  const [form] = Form.useForm();
  const studentListT: any = getLangList("studentList");

  useEffect(() => {
    getAllTeacherAccountFunction();
  }, []);

  useEffect(() => {
    if (Object.keys(teacherInfo).length > 0) {
      const { userAccountId } = teacherInfo;
      const selectedStudent = teacherArray?.find((item: TeacherType) => item.userAccountId === userAccountId) ?? {} as TeacherType;
      setTeacherInfo(selectedStudent);
    }
  }, [teacherArray, teacherInfo]);

  function getAllTeacherAccountFunction() {
    getAllTeacherAccount().then((res: any) => {
      const teacherArray = res?.value ?? [];
      setTeacherArray(teacherArray);
    });
  };

  function getUserAccountIdDataArray() {
    return teacherArray.map((item: TeacherType) => {
      const { nameCn, nameEn, departmentName, userAccountId } = item;
      return { value: userAccountId, label: `${nameCn}-${nameEn}-${departmentName}` }
    });
  }

  function onChangeStudent(userAccountId: number) {
    const selectedTeacher = teacherArray?.find((item: TeacherType) => item.userAccountId === userAccountId) ?? {} as TeacherType;
    setTeacherInfo(selectedTeacher);
  }

  return (
    <Row gutter={[0, 8]} justify="center">
      <Col>
        <Form form={form}>
          <Form.Item name="teacherInfo" label={studentListT.PERSON_SEARCH}>
            <Select
              showSearch
              allowClear
              style={{ width: "400px" }}
              optionFilterProp="children"
              filterOption={(input: any, option: any) => selectFilterOption(input, option)}
              onChange={onChangeStudent}
            >
              {getOptionArray(getUserAccountIdDataArray())}
            </Select>
          </Form.Item>
        </Form>
      </Col>

      <Col span={24}>
        {Object.keys(teacherInfo).length > 0
          ? <TeacherSingle
            teacherInfo={teacherInfo}
            getAllTeacherAccountFunction={getAllTeacherAccountFunction}
          />
          : <Teachers
            teacherArray={teacherArray}
            getAllTeacherAccountFunction={getAllTeacherAccountFunction}
          />
        }
      </Col>
    </Row>
  )
}

export default TeacherManagement;